import { render, staticRenderFns } from "./RichtextToolsToggleButton.vue?vue&type=template&id=ff6009fe"
import script from "./RichtextToolsToggleButton.vue?vue&type=script&lang=js"
export * from "./RichtextToolsToggleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports